<template>
  <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Registro de Cargas</h3>
            <div class="form-row">
              <div class="form-group col col-md-6">
                  <label for="type_ship" class="badge badge-primary">Destino Actividad</label>
                  <select class="form-control" name="type_ship" v-model="service_master_select" @change="mCallService">
                    <option v-for="activity in list_service" :value="activity.id" :key="activity.id">{{ activity.detail }}</option>
                  </select>
              </div>

              <transition name="fade" mode="out-in">
                  <div class="form-group col col-md-6" v-if="type_services.length > 0">
                    <label for="type_service" class="badge badge-primary">Tipo de Servicio</label>
                    <select class="form-control" name="type_service" v-model="type_service_select">
                      <option v-for="service in type_services" :value="service" :key="service.id">{{ service.detail }}</option>
                    </select>
                  </div>
              </transition>

            </div>
        </div>

            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-init-list" data-toggle="tab" href="#nav-list-charge" role="tab" aria-controls="nav-home" aria-selected="true">Listado</a>
                    <a class="nav-item nav-link" id="nav-second-register" data-toggle="tab" href="#nav-register-charge" role="tab" aria-controls="nav-detail" aria-selected="false">Registro</a>
                </div>
            </nav>
        <div class="tab-content" id="nav-tabContent">
                
          <div class="tab-pane fade show active" id="nav-list-charge" role="tabpanel" aria-labelledby="nav-home-tab">
              <br><div class="alert alert-info col col-md-8 offset-md-2">
                Listado de Cargas Correspondientes a cada categoria seleccionada
              </div>
              <button class="btn btn-outline-info col col-md-2 offset-md-5" v-if="type_services.length > 0" @click="mCallListCharge">Listar</button>
              <br>
              <div class="table-responsive" v-if="list_charge.length > 0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Codigo</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(lc,key) in list_charge" :key="lc.id">
                      <td>{{ key+1 }}</td>
                      <td>{{ lc.codigo_carga }} </td>
                      <td>{{ lc.carga_detail }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

          </div>

          <div class="tab-pane fade" id="nav-register-charge" role="tabpanel" aria-labelledby="nav-home-tab">
              <br><div class="alert alert-warning col col-md-8 offset-md-2">
                Registro de una carga NO existente en sistema
              </div>

              <div class="form-row">
                <div class="form-group col col-md-4 offset-md-2">
                  <label for="code">Codigo</label>
                  <input type="text" name="new_code_charge" id="new_code_charge" class="form-control" v-model="new_charge.code">
                </div>
                <div class="form-group col col-md-4">
                  <label for="name_charge">Detalle Carga</label>
                  <input type="text" name="new_name_charge" id="new_name_charge" class="form-control" v-model="new_charge.name">
                </div>
              </div>

              <button class="btn btn-warning col col-md-2 offset-md-5" @click="mRegisterCharge">Registrar</button>
          </div>
        </div>  
  
    
  </div>
    
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default {
  name:'register-charge',
  data(){
    return {
      list_service:[],
      type_services:[],
      list_charge:[],
      service_master_select:0,
      type_service_select:{},
      new_charge:{
        code:null,
        name:null
      }
    }
  },
  mounted(){
    this.mChargeInit();
  },
  methods:{
    async mChargeInit(){
      // llamamos la carga inicial de las categorias de servicio
      let services = await axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`);
      console.log(services);
      this.list_service=services.data;
    },
    async mCallService(){
      this.type_services=[];
      let aux_service=await axios.get(`submenus/${this.service_master_select}?api_token=${Vue.auth.getToken()}`);
      this.type_services=aux_service.data;
      // console.log()
    },
    async mCallListCharge(){
      if(this.type_service_select.id > 0){
        this.list_charge=[];
        let list_charge_aux=await axios.get(`SearchLoadCategory/${this.type_service_select.id}?api_token=${Vue.auth.getToken()}`);
        console.log(list_charge_aux);
        this.list_charge=list_charge_aux.data;
      }else{
        toastr.warning('Seleccione todas las opciones del formulario', 'Advertencia');
      }
    },
    mRegisterCharge(){
      if(this.new_charge.code!==null && this.new_charge.name !== null){

        let message = {
                    title: 'Registro de Carga',
                    body: `Usted esta a punto de Registrar la Carga : <br> categoria <b>${this.type_service_select.detail}</b><br>codigo: <b>${this.new_charge.code}</b> y nombre : <b>${this.new_charge.name}</b>`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                  if(msg){
                    try {
                      let param={
                        id_master:this.type_service_select.id,
                        n_code:this.new_charge.code,
                        n_name:this.new_charge.name
                      }
                      axios.post(`insertNewCharge?api_token=${Vue.auth.getToken()}`,
                                    qs.stringify(param))
                                  .then(res=>{                        
                                      setTimeout(()=>{
                                          console.log(res);
                                          if(res.data.state){
                                            toastr.success(`${res.data.respuesta}`, 'Exito')
                                            this.new_charge.code=null;
                                            this.new_charge.name=null;
                                          }else{
                                            toastr.error(`${res.data.respuesta}`, 'Error')
                                          }
                                          

                                      }, 2000);
                                      
                                  }).catch(error => {
                                      setTimeout(()=>{                                    
                                          toastr.error('Verifique la si su session aun esta activa','Error');
                                      }, 3000);
                                      console.log(error)
                                  })
                    } catch (error) {
                      
                    }
                  }else{

                  }
                })


        
      }else{
        toastr.warning(`Indique el codigo y el nombre de la carga`, 'Advertencia');
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/config/registerCharge.vue